import React from "react";
import classNames from "classnames";
import styles from "./BoxContent.scss";

export const BoxContent = ({ border, padding, children, grow, color, collapsed, roundTop, roundBottom, editing }) => {
    return (
        <div
            className={classNames(styles.content, {
                [styles.roundTop]: roundTop,
                [styles.roundBottom]: roundBottom,
                [styles.editing]: editing,
                [styles.borderTop]: border?.indexOf("top") >= 0,
                [styles.borderBottom]: border?.indexOf("bottom") >= 0,
                [styles.borderRight]: border?.indexOf("right") >= 0,
                [styles.borderLeft]: border?.indexOf("left") >= 0,
                [styles.paddingNone]: padding === "none",
                [styles.paddingSmall]: padding === "small",
                [styles.grow]: grow,
                [styles.colorNote]: color === "note",
                [styles.colorAttention]: color === "attention",
                [styles.colorSuccess]: color === "success",
                [styles.colorError]: color === "error",
                [styles.colorSilent]: color === "silent",
                [styles.colorStriped]: color === "striped",
                [styles.collapsed]: collapsed
            })}
        >
            <div className={styles.wrapper}>{children}</div>
        </div>
    );
};
